//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    props:["aksi"],
    data() {
        return { 
        }
    },
    
 

 


    
}
